// extracted by mini-css-extract-plugin
export default {"header":"Header_header__O0E1Z","vertical":"Header_vertical__8x1bC","header__title":"Header_header__title__qFxRC","backButton__title":"Header_backButton__title__9nQXy"};